TPS.RetailerAgreement = {

    init: function () { },

}
